import {budget} from './Budget';
import {dailyBudget} from './DailyBudget';
import {moneyBox} from './MoneyBox';
import {history} from './History';
import {lastRecalcDateTime} from './LastRecalcDateTime';
import {userInput} from './UserInput';
import {settingsView} from './Settings';
import {coreSettings} from './CoreSettings';
import {ui} from './UI';

export * from './CoreSettings';

export const reducerRegistry = {
  budget,
  dailyBudget,
  moneyBox,
  history,
  userInput,
  settingsView,
  settings: coreSettings,
  lastRecalcDateTime,
  ui,
};
